const v16 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        topScriptTopicsTable: {
          ...state.options.tableViews.topScriptTopicsTable,
          "AI Suggestions": true,
        },
        topThumbTopicsTable: {
          ...state.options.tableViews.topThumbTopicsTable,
          "AI Suggestions": true,
        },
        topTitleTopicsTable: {
          ...state.options.tableViews.topTitleTopicsTable,
          "AI Suggestions": true,
        },
        topVideoTypesTable: {
          ...state.options.tableViews.topVideoTypesTable,
          "AI Suggestions": true,
        },
      },
    },
  };
};

export default v16;
